import filterInput from './fiter-input.vue';
export default filterInput


// WEBPACK FOOTER //
// ./src/views/my-components/table-filter-input/index.js